import { createSSRApp } from "vue";

if (typeof dispatch !== "undefined") {
  (async () => {
    const moduleParentDirectory = context.modulePath ?? context.module;
    let module;
    if (context.designsystem) {
      module = await import(
        `../../designsystem/src/components/${moduleParentDirectory}/${context.module}.vue`
      );
    } else {
      module = await import(`./${moduleParentDirectory}/${context.module}.vue`);
    }

    const app = createSSRApp(module.default, context || {});
    const { renderToString } = await import("@vue/server-renderer");
    renderToString(app).then((html) => {
      dispatch(html);
    });
  })();
} else {
  const appContainers = document.querySelectorAll(".js-ssrApp");
  appContainers.forEach((appContainer) => {
    const props = JSON.parse(appContainer.dataset.context);
    const moduleParentDirectory = props.modulePath ?? props.module;

    //Dynamically import JS when it's under 300px below the viewport
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(async (entry) => {
          if (entry.intersectionRatio > 0) {
            let module;
            //add event listeners
            for (const key in props) {
              if (key.startsWith("on")) {
                props[key] = eval(props[key]);
              }
            }
            if (props.designsystem) {
              module = await import(
                `../../designsystem/src/components/${moduleParentDirectory}/${props.module}.vue`
              );
            } else {
              module = await import(
                `./${moduleParentDirectory}/${props.module}.vue`
              );
            }
            const app = createSSRApp(module.default, props);
            app.mount(appContainer);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: "0px 0px 300px 0px",
      }
    );
    observer.observe(appContainer);
  });
}
